import { Dispatch } from '@reduxjs/toolkit';
import axiosInstance, { ApiKeys, getApiUrl } from 'src/utils/ApiHelper';
import { setActionEvents } from 'src/reducers/commonSlice';
import { logError } from 'src/utils/ApiHelper';
import { API_STATUS_CODE } from '@cp/src/utils/ApiHelperUtils';

export const getActivePendingActions =
  (caseReferenceId: string, loanaccountnumber: string, customerreferenceid: string) =>
  (dispatch: Dispatch) => {
    const url = getApiUrl(ApiKeys.GET_ACTIVE_ACTIONS, { caseReferenceId });

    axiosInstance
      .get(url, {
        headers: {
          customerreferenceid: customerreferenceid,
          loanaccountnumber: loanaccountnumber,
          donotHandleError: true
        }
      })
      .then(response => {
        dispatch(setActionEvents(response?.data?.actionEvents));
      })
      .catch(error => {
        logError(error);
      });
  };

export const acknowledgePendingAction = (actionReferenceId: string) => () => {
  const url = getApiUrl(ApiKeys.ACKNOWLEDGE_ACTION, { actionReferenceId });

  return axiosInstance
    .post(url)
    .then(response => response?.status === API_STATUS_CODE.OK)
    .catch(error => {
      logError(error);
      return false;
    });
};
